import { useFeatureFlags } from '@brightdrop/feature-flags-client';

import {
  getBrandName,
  ONSTAR_FLEET_INTELLIGENCE_REBRAND_FLAG,
} from './brand.constants';

/**
 * Returns the brand label to show in user-facing copy, resolved from the
 * rebrand flag. Legacy brand when the flag is off, current brand when on.
 */
export const useBrandName = (): string => {
  const { getFlag } = useFeatureFlags();
  return getBrandName(Boolean(getFlag(ONSTAR_FLEET_INTELLIGENCE_REBRAND_FLAG)));
};
